// @ts-expect-error untyped module
import UIAvatar from 'ui-addon-avatars/UIAvatar';
import UIMediaObject from 'UIComponents/layout/UIMediaObject';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import ObjectNameLabel from 'flow-doctor-lib/components/common/ObjectNameLabel';
import ObjectProfileLabel from 'flow-doctor-lib/components/common/ObjectProfileLabel';
import EnrollmentReasonTag from 'flow-doctor-lib/components/diagnosis/details/EnrollmentReasonTag';
import { getIsInternal } from 'flow-doctor-lib/constants/Env';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ObjectProfile = ({
  diagnosisResult,
  enrollmentLogEvent
}) => {
  const {
    objectId,
    objectTypeId,
    portalId
  } = enrollmentLogEvent;
  if (objectTypeId === '0-1') {
    // UIAvatar won't work on tools.hubteam domain as it requires app auth
    return /*#__PURE__*/_jsx(UIMediaObject, {
      itemLeft: !getIsInternal() && /*#__PURE__*/_jsx(View, {
        marginInlineEnd: "200",
        children: /*#__PURE__*/_jsx(UIAvatar, {
          vid: objectId,
          portalId: portalId,
          size: "md"
        })
      }),
      children: /*#__PURE__*/_jsx(ObjectProfileLabel, {
        objectId: objectId,
        objectTypeId: objectTypeId,
        portalId: portalId,
        showId: getIsInternal(),
        tag: /*#__PURE__*/_jsx(EnrollmentReasonTag, {
          diagnosisResult: diagnosisResult
        })
      })
    });
  }
  return /*#__PURE__*/_jsxs("div", {
    style: {
      display: 'flex'
    },
    children: [/*#__PURE__*/_jsx(Text, {
      as: "h5",
      marginInlineEnd: "200",
      children: /*#__PURE__*/_jsx(ObjectNameLabel, {
        objectId: objectId,
        objectTypeId: objectTypeId,
        portalId: portalId,
        showId: getIsInternal()
      })
    }), /*#__PURE__*/_jsx(EnrollmentReasonTag, {
      diagnosisResult: diagnosisResult
    })]
  });
};
export default ObjectProfile;